<script lang="ts">
	import Text from '../Text.svelte';

	export let label: string | undefined = undefined;

	/** the start of the global text key for getting the label, "__rating" (e.g. "__0") will be appended by to get the relevant label */
	export let labelKeyPrefix: string | undefined = undefined;
	export let rating: number;
	export let maxRating: number = 5;
</script>

<div class="circle-rating">
	<div class="circles">
		{#each new Array(maxRating) as _, idx}
			<div class="circle" class:filled={idx + 1 <= rating} />
		{/each}
	</div>
	{#if labelKeyPrefix}
		<div class="label">
			<Text key={labelKeyPrefix + '__' + rating} />
		</div>
	{/if}
</div>

<style lang="scss">
	.circle-rating {
		display: flex;
		gap: v(content-gap-sm);
		align-items: center;
		flex-wrap: wrap;
	}

	.circles {
		display: flex;
		gap: 2px;
	}

	.circle {
		height: 8px;
		aspect-ratio: 1;
		border-radius: 50%;
		border: 1px solid color(black);

		&.filled {
			background: color(black);
		}
	}

	.label {
		@include font(text);
	}
</style>
